// @flow
import React, {useState} from 'react';

import Box from 'sail/Box';
import {MenuItem} from 'sail/Menu';
import {Text} from 'sail/Text';
import MenuContainer from 'sail/MenuContainer';
import {useAccount, useAnalytics, useNavigation} from 'docs/data';
import type {Locale} from 'docs/data';
import {SelectorLink} from './SelectorLink';

type LocaleSelectorProps = {|
  showLabel?: boolean,
|};

export const LocaleSelector = ({showLabel = true}: LocaleSelectorProps) => {
  const [showMenu, setShowMenu] = useState(false);
  const {account, isLoading, setLocale} = useAccount();
  const {trackAction} = useAnalytics();
  const {setNavigation} = useNavigation();

  const locales = account.availableLocales;

  const handleLocaleSelected = (locale: Locale) => {
    setLocale(locale, setNavigation);
    trackAction('docs_locale_changed', {newLocale: locale.code});
    setShowMenu(false);
  };

  return (
    <MenuContainer
      contextMeetingPoint="topleft"
      layerMeetingPoint="bottomleft"
      offsetX={6}
      contents={
        <Box padding={{vertical: 16, horizontal: 12}}>
          {locales.map((locale) => (
            <MenuItem
              key={locale.code}
              onClick={() => handleLocaleSelected(locale)}
            >
              <Text
                color={
                  locale.code === account.locale.code ? 'inherit' : 'default'
                }
              >
                {locale.name}
              </Text>
            </MenuItem>
          ))}
        </Box>
      }
      onMenuStateChange={(value) => setShowMenu(value)}
      showMenu={showMenu}
    >
      <SelectorLink
        label={account.locale.name}
        icon="locale"
        pending={isLoading}
        showLabel={showLabel}
      />
    </MenuContainer>
  );
};
